import { render, staticRenderFns } from "./AdConsentModal.vue?vue&type=template&id=64452604&scoped=true"
import script from "./AdConsentModal.vue?vue&type=script&lang=js"
export * from "./AdConsentModal.vue?vue&type=script&lang=js"
import style0 from "./AdConsentModal.vue?vue&type=style&index=0&id=64452604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64452604",
  null
  
)

export default component.exports